<template>
  <div id="footerMenu" class="bg-white rounded-t-lg">
    <div v-if="isInOnlinePayment === 'true' || isInOnlinePayment === true" class="row align-items-center text-center">
    <router-link class="col py-0" to="OnlinePaymentHome">
      <div :class="getClass('home')">
        <div>
          <i class="fa-regular fa-gem fa-2xl"></i>
        </div>
        <div class="mt-3 primary-text">ویترین</div>
      </div>
    </router-link>
    <router-link :to="{name:'ProductsList',params:{active:'online'},query:{isOnline:'true'}}" class="col py-0">
      <div :class="getClass('products')">
        <i class="fa-regular fa-bag-shopping fa-2xl"></i>
        <div class="mt-3 primary-text">محصولات</div>
      </div>
    </router-link>
    <router-link :to="{name:'StoreList',params:{active:'online'},query:{isOnline:'true'}}" class="col py-0">
      <div :class="getClass('stores')">
        <div>
          <i class="fa-regular fa-store fa-2xl"></i>
        </div>
        <div class="mt-3 primary-text">فروشگاه ها</div>
      </div>
    </router-link>
    </div>
    <div v-else class="row align-items-center text-center">
      <router-link class="col py-0" to="OfflinePaymentHome">
        <div :class="getClass('home')">
          <div>
            <i class="fa-regular fa-gem fa-2xl"></i>
          </div>
          <div class="mt-3 primary-text">ویترین</div>
        </div>
      </router-link>
      <router-link :to="{name:'ProductsList',params:{active:'offline'},query:{isOnline:'false'}}" class="col py-0">
        <div :class="getClass('products')">
          <i class="fa-regular fa-bag-shopping fa-2xl"></i>
          <div class="mt-3 primary-text">محصولات</div>
        </div>
      </router-link>
      <router-link :to="{name:'StoreList',params:{active:'offline'},query:{isOnline:'false'}}" class="col py-0">
        <div :class="getClass('stores')">
          <div>
            <i class="fa-regular fa-store fa-2xl"></i>
          </div>
          <div class="mt-3 primary-text">فروشگاه ها</div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentsFooter",
  props: ['currentPage','isInOnlinePayment'],
  data:()=>({
  }),
  mounted() {
  },
  methods: {
    getClass(linkName) {
      let classList = "col text-center";
      if (linkName === this.currentPage) {
        classList += " active";
      }
      return classList;
    },
  }
}
</script>

<style scoped>

</style>